import { render, staticRenderFns } from "./ServiceRadioFormPart.vue?vue&type=template&id=6aaa4ac8"
import script from "./ServiceRadioFormPart.vue?vue&type=script&lang=js"
export * from "./ServiceRadioFormPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports